<script setup lang="ts"></script>

<template>
  <div class="socials d-flex justify-content-between">
    <a class="text-center" target="_blank" href="https://github.com/erictarter">
      <i class="lni lni-github fs-2"></i>
    </a>
    <a
      target="_blank"
      href="https://www.linkedin.com/in/eric-tarter-b2549a203/">
      <i class="lni lni-linkedin-original fs-2"></i>
    </a>
  </div>
</template>

<style scoped lang="scss">
  a {
    color: rgb(54, 55, 65);
    padding: 0.1rem 0.3rem;
    transition: 0.2s ease all;
    cursor: pointer;
  }

  a:hover {
    transition: 0.2s ease all;
    color: #777b82;
  }
</style>
